import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

const enum PageIdWoofzPn {
  SEX_PN = PageId.SEX_PN,
  URGE_PN = PageId.URGE_PN,
  BIGGEST_CHALLENGE_PN = PageId.BIGGEST_CHALLENGE_PN,
  DOG_AGE_PN = PageId.DOG_AGE_PN,
  DOG_BREED_PN = PageId.DOG_BREED_PN,
  DOG_BREED_ID_PN = PageId.DOG_BREED_ID_PN,
  CHALLENGES_PN = PageId.CHALLENGES_PN,
  FEELINGS_PN = PageId.FEELINGS_PN,
  URGE_2_PN = PageId.URGE_2_PN,
  REACTION_PN = PageId.REACTION_PN,
  YELLING_MOMENTS_PN = PageId.YELLING_MOMENTS_PN,
  BARKING_PN = PageId.BARKING_PN,
  URGE_3_PN = PageId.URGE_3_PN,
  IMPROVE_PN = PageId.IMPROVE_PN,
  FOLLOW_COMMANDS_PN = PageId.FOLLOW_COMMANDS_PN,
  COMMANDS_61_PN = PageId.COMMANDS_61_PN,
  COMMANDS_62_PN = PageId.COMMANDS_62_PN,
  COMMANDS_63_PN = PageId.COMMANDS_63_PN,
  URGE_4_PN = PageId.URGE_4_PN,
  TOYS_PN = PageId.TOYS_PN,
  FREQUENCY_PN = PageId.FREQUENCY_PN,
  PREPARE_FLOW_PN = PageId.PREPARE_FLOW_PN,
  DOG_STATISTICS_PN = PageId.DOG_STATISTICS_PN,
  EMAIL_PN = PageId.EMAIL_PN,
  NEWSLETTER_URGE_PN = PageId.NEWSLETTER_URGE_PN,
  LAST_CHANCE_OFFER_PN = PageId.LAST_CHANCE_OFFER_PN,
  SUBSCRIPTIONS_PN = PageId.SUBSCRIPTIONS_PN,
  CHAT_UPSELL_PN = PageId.CHAT_UPSELL_PN,
  UPSELL_PN = PageId.UPSELL_PN,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_PN = PageId.DOWNLOAD_PN,
}

type TIdToPageMapWoofzPn = Record<PageIdWoofzPn, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZPN: TIdToPageMapWoofzPn = {
  sex_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/DogSexQuestion').then(
        (m) => ({
          default: m.DogSexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/DogSexQuestion'),
  },
  urge_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/urge/UrgePageVariant1').then(
        (m) => ({
          default: m.UrgePageVariant1,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_pn/pages/urge/UrgePageVariant1'),
  },
  dog_age_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/DogAgeQuestion'),
  },
  biggest_challenge_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/BiggestChallenge').then(
        (m) => ({
          default: m.BiggestChallengeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/BiggestChallenge'),
  },
  dog_breed_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/DogBreedQuestion').then(
        (m) => ({
          default: m.DogBreedQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/DogBreedQuestion'),
  },
  dog_breed_id_pn: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pn/pages/questions/breedId/BreedPhotoScreen'
      ).then((m) => ({
        default: m.BreedPhotoScreen,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/breedId/BreedPhotoScreen'),
  },
  challenges_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/ChallengesQuestion').then(
        (m) => ({
          default: m.ChallengesQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/ChallengesQuestion'),
  },
  feelings_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/FeelingsQuestion').then(
        (m) => ({
          default: m.FeelingsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/FeelingsQuestion'),
  },
  urge_2_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_pn/pages/urge/UrgePageVariant2'),
  },
  reaction_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/ReactionQuestion').then(
        (m) => ({
          default: m.ReactionQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/ReactionQuestion'),
  },
  yelling_moments_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/YellingQuestion').then(
        (m) => ({
          default: m.YellingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/YellingQuestion'),
  },
  barking_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/BarkingQuestion').then(
        (m) => ({
          default: m.BarkingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/BarkingQuestion'),
  },
  urge_3_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_pn/pages/urge/UrgePageVariant3'),
  },
  improve_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/ImprovePage').then(
        (m) => ({
          default: m.ImprovePage,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_pn/pages/questions/ImprovePage'),
  },
  follow_commands_pn: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pn/pages/questions/FollowCommandsQuestion'
      ).then((m) => ({
        default: m.FollowCommandsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/FollowCommandsQuestion'),
  },
  commands_61_pn: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pn/pages/questions/CommandsQuestionVariant61'
      ).then((m) => ({
        default: m.CommandsQuestionVariant61,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pn/pages/questions/CommandsQuestionVariant61'
      ),
  },
  commands_62_pn: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pn/pages/questions/CommandsQuestionVariant62'
      ).then((m) => ({
        default: m.CommandsQuestionVariant62,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pn/pages/questions/CommandsQuestionVariant62'
      ),
  },
  commands_63_pn: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pn/pages/questions/CommandsQuestionVariant63'
      ).then((m) => ({
        default: m.CommandsQuestionVariant63,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pn/pages/questions/CommandsQuestionVariant63'
      ),
  },
  urge_4_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_pn/pages/urge/UrgePageVariant4'),
  },
  toys_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/ToysQuestion').then(
        (m) => ({
          default: m.ToysQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/ToysQuestion'),
  },
  frequency_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/questions/FrequencyQuestion').then(
        (m) => ({
          default: m.FrequencyQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/questions/FrequencyQuestion'),
  },
  prepare_flow_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/prepare-flow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/prepare-flow/PrepareFlow'),
  },
  dog_statistics_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/dog-statistics/DogStatistics').then(
        (m) => ({
          default: m.DogStatistics,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/dog-statistics/DogStatistics'),
  },
  email_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/email/EmailPage').then((m) => ({
        default: m.EmailPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pn/pages/email/EmailPage'),
  },
  newsletter_urge_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/email/NewsletterUrge').then((m) => ({
        default: m.NewsletterUrgePn,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pn/pages/email/NewsletterUrge'),
  },
  last_chance_offer_pn: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pn/pages/last-chance-offer/LastChanceOfferSpin'
      ).then((m) => ({ default: m.LastChanceOfferSpin })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pn/pages/last-chance-offer/LastChanceOfferSpin'
      ),
  },
  subscriptions_pn: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pn/pages/subscriptions/SubscriptionsPage'
      ).then((m) => ({
        default: m.SubscriptionsPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/subscriptions/SubscriptionsPage'),
  },
  chat_upsell_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/upsell/ChatUpsellNewFlow'),
  },
  upsell_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pn/pages/upsell/Upsell'),
  },
  account_nove8: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  download_pn: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pn/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pn/pages/download-app/DownloadApp'),
  },
}
